module.exports = __webpack_public_path__ + "37fa70954956a488c98e7e11c1576465.svg";